/**
 * @description: This is copied from the auto generated types, but we have a bug with the auto generated types
 *     when they are "magically" imported globally. If you need to use them in our code, you must import directly.
 */
export var PaymentCurrencyType;
(function (PaymentCurrencyType) {
    PaymentCurrencyType["Gbp"] = "GBP";
    PaymentCurrencyType["Eur"] = "EUR";
    PaymentCurrencyType["Aud"] = "AUD";
})(PaymentCurrencyType || (PaymentCurrencyType = {}));
export var PaymentOrderStatus;
(function (PaymentOrderStatus) {
    PaymentOrderStatus["Pending"] = "PENDING";
    PaymentOrderStatus["Completed"] = "COMPLETED";
    PaymentOrderStatus["Failed"] = "FAILED";
    PaymentOrderStatus["Refunded"] = "REFUNDED";
    PaymentOrderStatus["PartRefunded"] = "PART_REFUNDED";
})(PaymentOrderStatus || (PaymentOrderStatus = {}));
export var PaymentProvider;
(function (PaymentProvider) {
    PaymentProvider["Adyen"] = "ADYEN";
    PaymentProvider["AdyenClassic"] = "ADYEN_CLASSIC";
    PaymentProvider["Wallet"] = "WALLET";
})(PaymentProvider || (PaymentProvider = {}));
export var WalletType;
(function (WalletType) {
    WalletType["User"] = "personal";
    WalletType["Rewards"] = "rewards";
})(WalletType || (WalletType = {}));
export var PaymentStatus;
(function (PaymentStatus) {
    PaymentStatus["Pending"] = "PENDING";
    PaymentStatus["Completed"] = "COMPLETED";
    PaymentStatus["Failed"] = "FAILED";
    PaymentStatus["Refunded"] = "REFUNDED";
})(PaymentStatus || (PaymentStatus = {}));
export var PaymentCardType;
(function (PaymentCardType) {
    PaymentCardType["AmericanExpress"] = "amex";
    PaymentCardType["Mastercard"] = "mc";
    PaymentCardType["Visa"] = "visa";
})(PaymentCardType || (PaymentCardType = {}));
